export interface HomepageSubRoute {
  title: string;
  url: string;
  icon: string;
  hideWhenNewHomepage?: boolean;
}

export const HOMEPAGE_SUB_ROUTES: HomepageSubRoute[] = [
  {
    title: 'Home',
    url: '/',
    icon: 'IconHome'
  }
];
